import { redrawDevices } from 'src/components/Planner/planner/deviceDrawing';
import {
    toggleCategoryVisibility,
    toggleCategoryLock,
} from 'src/components/Planner/planner/categoryDisplayHandler';

export function executeToggleVisibility(subcategoryId: number): void {
    toggleCategoryVisibility(subcategoryId);
    redrawDevices();
}

export function executeToggleLock(subcategoryId: number): void {
    toggleCategoryLock(subcategoryId);
    redrawDevices();
}